
export const NEW_COMMENT_MARGIN_BOTTOM = "1.3em";
